var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view_box",class:_vm.isAni ? 'ani':''},[_c('div',{staticClass:"title"},[_vm._v("促复购Tips")]),_c('div',{staticClass:"text_font"},[_vm._v("趣味互动加成——老客持续活跃必备")])])
}
var staticRenderFns = []

export { render, staticRenderFns }